import React from 'react';
import './LegalPage.css';

function PrivacyPolicy() {
  return (
    <main className="legal-page">
      <header className="legal-header">
        <a className="legal-brand" href="/">Growth <span>Sparrow</span></a>
        <a className="legal-back" href="/">Back to website</a>
      </header>

      <article className="legal-content">
        <span className="legal-eyebrow">Growth Sparrow · Legal</span>
        <h1>Privacy Policy</h1>
        <p className="legal-intro">
          Growth Sparrow respects your privacy and is committed to handling your
          information responsibly, transparently, and securely.
        </p>
        <p className="legal-updated">Last updated: 24 June 2025</p>

        <div className="legal-card">
          <section>
            <h2>1. Who we are</h2>
            <p>
              This Privacy Policy explains how Growth Sparrow (“Growth Sparrow,”
              “we,” “us,” or “our”) collects, uses, stores, and protects
              information when you visit our website or submit a booking request.
            </p>
            <div className="legal-contact">
              <strong>Privacy contact</strong>
              <a href="mailto:office@growthsparrow.com">office@growthsparrow.com</a>
            </div>
          </section>

          <section>
            <h2>2. Information we collect</h2>
            <p>
              We collect only the information reasonably necessary to operate our
              website, respond to enquiries, and arrange requested conversations.
            </p>
            <h3>Information you provide</h3>
            <ul>
              <li>Your name and business or organisation name.</li>
              <li>Your email address and contact number.</li>
              <li>The service you are interested in.</li>
              <li>Your preferred booking date and time.</li>
              <li>Any information you choose to include in a message or enquiry.</li>
            </ul>
            <h3>Information collected automatically</h3>
            <p>
              Our hosting and security systems may receive technical information
              such as your IP address, browser type, device type, approximate
              location, referring page, and pages visited. This information is
              used for security, performance, and aggregate website analytics.
            </p>
          </section>

          <section>
            <h2>3. How we use information</h2>
            <ul>
              <li>To respond to your enquiry or booking request.</li>
              <li>To confirm, reschedule, or follow up on an appointment.</li>
              <li>To provide information about Growth Sparrow services you requested.</li>
              <li>To maintain, secure, troubleshoot, and improve the website.</li>
              <li>To prevent fraud, abuse, spam, and other harmful activity.</li>
              <li>To comply with legal obligations and enforce our agreements.</li>
            </ul>
            <p>
              We do not sell your personal information. We do not use booking
              information for unrelated marketing without an appropriate legal
              basis or your consent.
            </p>
          </section>

          <section>
            <h2>4. Sharing and service providers</h2>
            <p>
              We may share information with trusted providers that help us host
              the website, securely store booking requests, deliver email, or
              provide technical and security services. These providers may use
              information only to perform services on our behalf.
            </p>
            <p>
              We may also disclose information where required by law, to protect
              our rights and users, or in connection with a merger, acquisition,
              financing, or sale of business assets.
            </p>
          </section>

          <section>
            <h2>5. Cookies and similar technologies</h2>
            <p>
              The website may use essential cookies or local storage to support
              basic functionality, security, and preferences. Where analytics or
              other non-essential technologies are used, they may collect
              information about how visitors interact with the website.
            </p>
            <p>
              You can control cookies through your browser settings. Blocking
              certain cookies may affect website functionality.
            </p>
          </section>

          <section>
            <h2>6. Data retention and security</h2>
            <p>
              We retain personal information only for as long as reasonably
              necessary for the purposes described in this Policy, including
              providing services, resolving disputes, maintaining records, and
              meeting legal requirements.
            </p>
            <p>
              We use reasonable administrative, technical, and organisational
              safeguards to protect information. No internet transmission or
              storage system is completely secure, so we cannot guarantee absolute
              security.
            </p>
          </section>

          <section>
            <h2>7. Your choices and rights</h2>
            <p>
              Depending on where you live, you may have rights to request access
              to, correction of, deletion of, or restriction of processing of your
              personal information. You may also object to certain processing or
              withdraw consent where processing is based on consent.
            </p>
            <p>
              To make a privacy request, contact us at{' '}
              <a href="mailto:office@growthsparrow.com">office@growthsparrow.com</a>.
              We may need to verify your identity before completing a request.
            </p>
          </section>

          <section>
            <h2>8. Children’s privacy</h2>
            <p>
              Our website and services are intended for businesses and
              professionals and are not directed to children. We do not knowingly
              collect personal information from children.
            </p>
          </section>

          <section>
            <h2>9. Changes to this Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The updated
              version will be posted on this page with a revised “Last updated”
              date. Your continued use of the website after an update means the
              updated Policy applies to your use of the website.
            </p>
          </section>
        </div>
      </article>

      <p className="legal-footer">© 2025 Growth Sparrow. All rights reserved.</p>
    </main>
  );
}

export default PrivacyPolicy;